export enum ChallengeTypeEnum {
  ALL_TOGETHER = 'ALL_TOGETHER'
}
